import { updateQueryParamsByFilters } from "../../../../../../magnolia-component-library/assets/js/utils/queryParams";
import {
    populateFilters,
    addFiltersEventListeners,
    filterExtensions,
    propagateFiltersToDOM,
} from "./filters/index";
import {
    populateListItems,
    toggleNoResultsEl,
    addClearFiltersEventListener,
    toggleClearFiltersEls,
} from "./utils";
import { queryParams } from "./queryParams";
import { filterFilterCards } from "./filterCards";

export default function(el) {
    const state = {
        extensions: [],
        filteredExtensions: [],
        filters: {},
        filterCards: [],
        activeFilterCard: null,
        noResultsEl: el.querySelector(".el__no-results"),
        clearFiltersEls: el.querySelectorAll(".el__clear-filters"),
    };

    state.extensions = populateListItems(el, ".extension");
    state.filterCards = populateListItems(el, ".fc");
    state.filters = populateFilters(el);

    updateQueryParamsByFilters(queryParams, state.filters);
    propagateFiltersToDOM(state.filters, "setValue");
    filterFilterCards(state);
    filterExtensions(state);
    toggleNoResultsEl(state.noResultsEl, state.filteredExtensions.length);
    toggleClearFiltersEls(state.clearFiltersEls, state.filters);

    addFiltersEventListeners(state);
    addClearFiltersEventListener(state.clearFiltersEls, state);
}
